export function IconSettings() {
    return (
        <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
            <path
                d="M12 8.8a3.2 3.2 0 1 0 0 6.4 3.2 3.2 0 0 0 0-6.4Zm8.2 3.2c0-.4 0-.8-.1-1.2l1.8-1.4-1.8-3.1-2.2.9a7.9 7.9 0 0 0-2-.9l-.3-2.3H9.4l-.3 2.3a7.9 7.9 0 0 0-2 .9l-2.2-.9-1.8 3.1 1.8 1.4c-.1.4-.1.8-.1 1.2s0 .8.1 1.2l-1.8 1.4 1.8 3.1 2.2-.9c.6.4 1.3.7 2 .9l.3 2.3h4.2l.3-2.3c.7-.2 1.4-.5 2-.9l2.2.9 1.8-3.1-1.8-1.4c.1-.4.1-.8.1-1.2Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function IconLogs() {
    return (
        <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
            <path
                d="M6 4h9l3 3v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm8 1.5V8h2.5L14 5.5ZM7.5 11h9v1.6h-9V11Zm0 4h9v1.6h-9V15Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function IconCopy() {
    return (
        <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
            <path
                d="M9 8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V8Zm2 0v10h8V8h-8ZM3 6a2 2 0 0 1 2-2h1v2H5v10h2v2H5a2 2 0 0 1-2-2V6Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function IconSun() {
    return (
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="4" />
            <line x1="12" y1="2" x2="12" y2="5" />
            <line x1="12" y1="19" x2="12" y2="22" />
            <line x1="4.22" y1="4.22" x2="6.34" y2="6.34" />
            <line x1="17.66" y1="17.66" x2="19.78" y2="19.78" />
            <line x1="2" y1="12" x2="5" y2="12" />
            <line x1="19" y1="12" x2="22" y2="12" />
            <line x1="4.22" y1="19.78" x2="6.34" y2="17.66" />
            <line x1="17.66" y1="6.34" x2="19.78" y2="4.22" />
        </svg>
    );
}

export function IconMoon() {
    return (
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M21 12.79A9 9 0 1 1 11.21 3a7 7 0 0 0 9.79 9.79z" />
        </svg>
    );
}
